module.exports = __webpack_public_path__ + "img/e6.a2321f1b.png";